module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"fonts":{"google":[{"family":"Montserrat","variants":["400","500"]},{"family":"Iconsolata","variants":["400","500","600","700"]}]}},
    }]
